/* tslint:disable */
/* eslint-disable */
/**
 * OnData.Governance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BulkUpdateFieldGovernanceInput
 */
export interface BulkUpdateFieldGovernanceInput {
    /**
     * 
     * @type {BulkUpdateInfoInput}
     * @memberof BulkUpdateFieldGovernanceInput
     */
    'bulkUpdateInfo'?: BulkUpdateInfoInput;
    /**
     * 
     * @type {Array<BulkUpdateSelectedInput>}
     * @memberof BulkUpdateFieldGovernanceInput
     */
    'selected'?: Array<BulkUpdateSelectedInput> | null;
}
/**
 * 
 * @export
 * @interface BulkUpdateInfoInput
 */
export interface BulkUpdateInfoInput {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateInfoInput
     */
    'alias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateInfoInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof BulkUpdateInfoInput
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateInfoInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {EncryptMappingStatus}
     * @memberof BulkUpdateInfoInput
     */
    'encryptMappingStatus'?: EncryptMappingStatus;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateInfoInput
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateInfoInput
     */
    'customEncryptionRuleId'?: number | null;
    /**
     * 
     * @type {MaskingRule}
     * @memberof BulkUpdateInfoInput
     */
    'maskingRule'?: MaskingRule;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateInfoInput
     */
    'maskingValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateInfoInput
     */
    'retentionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateInfoInput
     */
    'reasonCollectId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateInfoInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface BulkUpdateSelectedInput
 */
export interface BulkUpdateSelectedInput {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateSelectedInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateSelectedInput
     */
    'tableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateSelectedInput
     */
    'fieldId'?: number;
}
/**
 * 
 * @export
 * @interface BulkUpdateValidationFailedIdsResponseDto
 */
export interface BulkUpdateValidationFailedIdsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateValidationFailedIdsResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateValidationFailedIdsResponseDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateValidationFailedIdsResponseDto
     */
    'fieldId'?: number;
}
/**
 * 
 * @export
 * @interface CheckDataAccessInput
 */
export interface CheckDataAccessInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckDataAccessInput
     */
    'dataAccessRoles'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CheckDataAccessInput
     */
    'dataAccessRoleIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CheckDataAccessInput
     */
    'isWrite'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckDataAccessInput
     */
    'secondaryClassificationId'?: number;
}
/**
 * 
 * @export
 * @interface ClassificationGrantsDto
 */
export interface ClassificationGrantsDto {
    /**
     * 
     * @type {Array<DataAccessRoleDto>}
     * @memberof ClassificationGrantsDto
     */
    'readDataAccessRoles'?: Array<DataAccessRoleDto> | null;
    /**
     * 
     * @type {Array<DataAccessRoleDto>}
     * @memberof ClassificationGrantsDto
     */
    'writeDataAccessRoles'?: Array<DataAccessRoleDto> | null;
}
/**
 * 
 * @export
 * @interface CollectionSchemaResponseDto
 */
export interface CollectionSchemaResponseDto {
    /**
     * 
     * @type {number}
     * @memberof CollectionSchemaResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CollectionSchemaResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CollectionSchemaResponseDto
     */
    'collectionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionSchemaResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionSchemaResponseDto
     */
    'partitionKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollectionSchemaResponseDto
     */
    'jsonSchema'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionSchemaResponseDto
     */
    'mappedCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionSchemaResponseDto
     */
    'pendingReviewCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionSchemaResponseDto
     */
    'totalRows'?: number;
}
/**
 * 
 * @export
 * @interface CreateDataAccessRoleInput
 */
export interface CreateDataAccessRoleInput {
    /**
     * 
     * @type {string}
     * @memberof CreateDataAccessRoleInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDataAccessRoleInput
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDataAccessRoleInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDataAccessRoleInput
     */
    'readGrants'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDataAccessRoleInput
     */
    'writeGrants'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CreateDataOwnerGroupInput
 */
export interface CreateDataOwnerGroupInput {
    /**
     * 
     * @type {string}
     * @memberof CreateDataOwnerGroupInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDataOwnerGroupInput
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateFieldTagInput
 */
export interface CreateFieldTagInput {
    /**
     * 
     * @type {string}
     * @memberof CreateFieldTagInput
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateReasonCollectInput
 */
export interface CreateReasonCollectInput {
    /**
     * 
     * @type {string}
     * @memberof CreateReasonCollectInput
     */
    'reasonText': string;
}
/**
 * 
 * @export
 * @interface CreateRetentionRuleInput
 */
export interface CreateRetentionRuleInput {
    /**
     * 
     * @type {string}
     * @memberof CreateRetentionRuleInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRetentionRuleInput
     */
    'days': number;
}
/**
 * 
 * @export
 * @interface CreateSecondaryClassificationInput
 */
export interface CreateSecondaryClassificationInput {
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof CreateSecondaryClassificationInput
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {string}
     * @memberof CreateSecondaryClassificationInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSecondaryClassificationInput
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardDatabaseStatisResponseDto
 */
export interface DashboardDatabaseStatisResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'lastBackupTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'publicCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'sensitiveCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'confidentialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'regulatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'naCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'ownedTableCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDto
     */
    'totalTableCount'?: number;
}
/**
 * 
 * @export
 * @interface DashboardDatabaseStatisResponseDtoPaginationResult
 */
export interface DashboardDatabaseStatisResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<DashboardDatabaseStatisResponseDto>}
     * @memberof DashboardDatabaseStatisResponseDtoPaginationResult
     */
    'items'?: Array<DashboardDatabaseStatisResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDatabaseStatisResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DataAccessRoleDto
 */
export interface DataAccessRoleDto {
    /**
     * 
     * @type {number}
     * @memberof DataAccessRoleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessRoleDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DataAccessRoleResponseDto
 */
export interface DataAccessRoleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DataAccessRoleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataAccessRoleResponseDto
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessRoleResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessRoleResponseDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessRoleResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DataAccessRoleResponseDto
     */
    'readGrants'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DataAccessRoleResponseDto
     */
    'writeGrants'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DataCatalogPaginationResult
 */
export interface DataCatalogPaginationResult {
    /**
     * 
     * @type {Array<DataCatalogResponseDto>}
     * @memberof DataCatalogPaginationResult
     */
    'items'?: Array<DataCatalogResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DataCatalogResponseDto
 */
export interface DataCatalogResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'schemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'alias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'firstSeen'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'lastSeen'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'position'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'scale'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataCatalogResponseDto
     */
    'isNullable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataCatalogResponseDto
     */
    'isIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataCatalogResponseDto
     */
    'isComputed'?: boolean;
    /**
     * 
     * @type {ExtraIgnoreItem}
     * @memberof DataCatalogResponseDto
     */
    'extraIgnoreItem'?: ExtraIgnoreItem;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof DataCatalogResponseDto
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {EncryptMappingStatus}
     * @memberof DataCatalogResponseDto
     */
    'encryptMappingStatus'?: EncryptMappingStatus;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'customEncryptionRuleId'?: number | null;
    /**
     * 
     * @type {MaskingRule}
     * @memberof DataCatalogResponseDto
     */
    'maskingRule'?: MaskingRule;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'maskingValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'retentionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogResponseDto
     */
    'reasonCollectId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DataCatalogResponseDto
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataCatalogResponseDto
     */
    'isPrimaryKey'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'primaryKeyName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataCatalogResponseDto
     */
    'isForeignKey'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'foreignKeyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'referencedSchemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'referencedTableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogResponseDto
     */
    'referencedFieldName'?: string | null;
}
/**
 * 
 * @export
 * @interface DataCatalogSelectAllItemResponseDto
 */
export interface DataCatalogSelectAllItemResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DataCatalogSelectAllItemResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DataCatalogSelectAllItemResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogSelectAllItemResponseDto
     */
    'schemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataCatalogSelectAllItemResponseDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogSelectAllItemResponseDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataCatalogSelectAllItemResponseDto
     */
    'fieldId'?: number;
}
/**
 * 
 * @export
 * @interface DataOwnerGroupResponseDto
 */
export interface DataOwnerGroupResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DataOwnerGroupResponseDto
     */
    'ownerGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataOwnerGroupResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataOwnerGroupResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataOwnerGroupResponseDto
     */
    'ownedTablesCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataOwnerGroupResponseDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface DatabaseMappingCountsResponseDto
 */
export interface DatabaseMappingCountsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DatabaseMappingCountsResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMappingCountsResponseDto
     */
    'mappedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMappingCountsResponseDto
     */
    'skippedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMappingCountsResponseDto
     */
    'pendingReviewCount'?: number;
}
/**
 * 
 * @export
 * @interface DatabaseOwnershipStatsDto
 */
export interface DatabaseOwnershipStatsDto {
    /**
     * 
     * @type {number}
     * @memberof DatabaseOwnershipStatsDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseOwnershipStatsDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DatabaseOwnershipStatsDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseOwnershipStatsDto
     */
    'engine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseOwnershipStatsDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseOwnershipStatsDto
     */
    'ownedCount'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DatabaseType {
    MySQL = 1,
    PostgreSQL = 2,
    SQLServer = 3,
    MongoDB = 4,
    MariaDB = 5,
    Oracle = 6,
    DB2 = 7,
    Hana = 8,
    Snowflake = 9,
    CosmosDB = 10
}

/**
 * 
 * @export
 * @interface EditCollectionMappingInput
 */
export interface EditCollectionMappingInput {
    /**
     * 
     * @type {number}
     * @memberof EditCollectionMappingInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditCollectionMappingInput
     */
    'collectionId': number;
    /**
     * 
     * @type {Array<PropertyMappingInput>}
     * @memberof EditCollectionMappingInput
     */
    'propertyMappings'?: Array<PropertyMappingInput> | null;
}
/**
 * 
 * @export
 * @interface EditEncryptionMappingInput
 */
export interface EditEncryptionMappingInput {
    /**
     * 
     * @type {number}
     * @memberof EditEncryptionMappingInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditEncryptionMappingInput
     */
    'tableId': number;
    /**
     * 
     * @type {Array<FieldMappingInput>}
     * @memberof EditEncryptionMappingInput
     */
    'fieldMappings'?: Array<FieldMappingInput> | null;
}
/**
 * 
 * @export
 * @interface EditTablesOwnershipEntryDto
 */
export interface EditTablesOwnershipEntryDto {
    /**
     * 
     * @type {number}
     * @memberof EditTablesOwnershipEntryDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditTablesOwnershipEntryDto
     */
    'ownerGroupId'?: number | null;
}
/**
 * 
 * @export
 * @interface EditTablesOwnershipInput
 */
export interface EditTablesOwnershipInput {
    /**
     * 
     * @type {number}
     * @memberof EditTablesOwnershipInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<EditTablesOwnershipEntryDto>}
     * @memberof EditTablesOwnershipInput
     */
    'list'?: Array<EditTablesOwnershipEntryDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EncryptMappingStatus {
    PendingReview = 0,
    Skipped = 1,
    Mapped = 2
}

/**
 * 
 * @export
 * @interface EncryptMappingStatusStatisticsResponseDto
 */
export interface EncryptMappingStatusStatisticsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptMappingStatusStatisticsResponseDto
     */
    'pendingReviewCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptMappingStatusStatisticsResponseDto
     */
    'skippedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptMappingStatusStatisticsResponseDto
     */
    'mappedCount'?: number;
}
/**
 * 
 * @export
 * @interface EncryptSettingsCopyAnalyseInfoDto
 */
export interface EncryptSettingsCopyAnalyseInfoDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'matchedCounts'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'matchedMappedCounts'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'matchedSkipedCounts'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'matchedObfsCounts'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'notMatchedOfSource'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'hasMappingCountOfSource'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'allMatched'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyAnalyseInfoDto
     */
    'destinationTableFieldCount'?: number;
}
/**
 * 
 * @export
 * @interface EncryptSettingsCopyInput
 */
export interface EncryptSettingsCopyInput {
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyInput
     */
    'sourceDatabaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyInput
     */
    'sourceTableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyInput
     */
    'destDatabaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptSettingsCopyInput
     */
    'destTableId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptSettingsCopyInput
     */
    'includeObfs'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof EncryptSettingsCopyInput
     */
    'obfsRulesToExclude'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface EncryptionMappingResponseDto
 */
export interface EncryptionMappingResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionMappingResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionMappingResponseDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionMappingResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionMappingResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EncryptionMappingResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof EncryptionMappingResponseDto
     */
    'mappingCreatedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionMappingResponseDto
     */
    'mappingModifiedTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptionMappingResponseDto
     */
    'mappedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionMappingResponseDto
     */
    'skippedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionMappingResponseDto
     */
    'pendingReviewCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionMappingResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionMappingResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionMappingResponseDto
     */
    'lastBackupTime'?: string | null;
}
/**
 * 
 * @export
 * @interface EncryptionRuleDataTypeMappingResponseDto
 */
export interface EncryptionRuleDataTypeMappingResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionRuleDataTypeMappingResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleDataTypeMappingResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleDataTypeMappingResponseDto
     */
    'sampleInput'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleDataTypeMappingResponseDto
     */
    'sampleOutput'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EncryptionRuleDataTypeMappingResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleDataTypeMappingResponseDto
     */
    'dataType'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum Encryptor {
    Alphabetic = 1,
    Alphanumeric = 2,
    CreditCard = 3,
    Date = 4,
    Email = 5,
    HexString = 6,
    Numeric = 7,
    String = 8,
    Integer = 9,
    Float = 10,
    Money = 11,
    UInteger = 12,
    MonthDay = 13,
    XML = 14,
    SSN = 15,
    ValidatedCardNumber = 16,
    Utf8String = 17
}

/**
 * 
 * @export
 * @interface EnumOptionResponseDto
 */
export interface EnumOptionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EnumOptionResponseDto
     */
    'key'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionResponseDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EnumOptionResponseDto
     */
    'databaseType'?: DatabaseType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ExtraIgnoreItem {
    None = 0,
    RowVersionGeneratedAlways = 1,
    TransitiveIdentity = 2
}

/**
 * 
 * @export
 * @interface FieldMappingInput
 */
export interface FieldMappingInput {
    /**
     * 
     * @type {number}
     * @memberof FieldMappingInput
     */
    'fieldId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FieldMappingInput
     */
    'isSkipped'?: boolean;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof FieldMappingInput
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingInput
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingInput
     */
    'customEncryptionRuleId'?: number | null;
    /**
     * 
     * @type {MaskingRule}
     * @memberof FieldMappingInput
     */
    'maskingRule'?: MaskingRule;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingInput
     */
    'maskingValue'?: string | null;
}
/**
 * 
 * @export
 * @interface FieldMappingResponseDto
 */
export interface FieldMappingResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FieldMappingResponseDto
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingResponseDto
     */
    'fieldName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingResponseDto
     */
    'dataType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingResponseDto
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingResponseDto
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingResponseDto
     */
    'scale'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingResponseDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldMappingResponseDto
     */
    'isSkipped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldMappingResponseDto
     */
    'isIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldMappingResponseDto
     */
    'isComputed'?: boolean;
    /**
     * 
     * @type {ExtraIgnoreItem}
     * @memberof FieldMappingResponseDto
     */
    'extraIgnoreItem'?: ExtraIgnoreItem;
    /**
     * 
     * @type {boolean}
     * @memberof FieldMappingResponseDto
     */
    'isPrimaryKey'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldMappingResponseDto
     */
    'isForeignKey'?: boolean;
    /**
     * 
     * @type {EncryptMappingStatus}
     * @memberof FieldMappingResponseDto
     */
    'encryptMappingStatus'?: EncryptMappingStatus;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingResponseDto
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldMappingResponseDto
     */
    'customEncryptionRuleId'?: number | null;
    /**
     * 
     * @type {MaskingRule}
     * @memberof FieldMappingResponseDto
     */
    'maskingRule'?: MaskingRule;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingResponseDto
     */
    'maskingValue'?: string | null;
}
/**
 * 
 * @export
 * @interface FieldTagResponseDto
 */
export interface FieldTagResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FieldTagResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldTagResponseDto
     */
    'tagId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldTagResponseDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum MaskingRule {
    None = 0,
    ReplaceWithCharacter = 1,
    ReplaceWithCharacterPreserveLastFour = 2,
    ReplaceWithDefaultDate = 3
}

/**
 * 
 * @export
 * @interface OwnerGroupAssignmentBrief
 */
export interface OwnerGroupAssignmentBrief {
    /**
     * 
     * @type {Array<TableOwnershipDto>}
     * @memberof OwnerGroupAssignmentBrief
     */
    'assignedTables'?: Array<TableOwnershipDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OwnerGroupAssignmentBrief
     */
    'totalTableCount'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PrimaryClassification {
    Public = 0,
    Sensitive = 1,
    Confidential = 2,
    Regulated = 3
}

/**
 * 
 * @export
 * @interface PrimaryClassificationStatisticsResponseDto
 */
export interface PrimaryClassificationStatisticsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'publicCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'sensitiveCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'confidentialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'regulatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'unclassifiedCount'?: number;
}
/**
 * 
 * @export
 * @interface PropertyMappingInput
 */
export interface PropertyMappingInput {
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingInput
     */
    'propertyId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyMappingInput
     */
    'isSkipped'?: boolean;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof PropertyMappingInput
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingInput
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingInput
     */
    'obfuscationRuleId'?: number | null;
}
/**
 * 
 * @export
 * @interface PropertyMappingResponseDto
 */
export interface PropertyMappingResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingResponseDto
     */
    'propertyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyMappingResponseDto
     */
    'collectionName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyMappingResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyMappingResponseDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingResponseDto
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingResponseDto
     */
    'scale'?: number | null;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof PropertyMappingResponseDto
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingResponseDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {EncryptMappingStatus}
     * @memberof PropertyMappingResponseDto
     */
    'encryptMappingStatus'?: EncryptMappingStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyMappingResponseDto
     */
    'isSkipped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyMappingResponseDto
     */
    'isPartitionKey'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingResponseDto
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {Encryptor}
     * @memberof PropertyMappingResponseDto
     */
    'encryptor'?: Encryptor;
    /**
     * 
     * @type {number}
     * @memberof PropertyMappingResponseDto
     */
    'obfuscationRuleId'?: number | null;
}
/**
 * 
 * @export
 * @interface ReasonCollectResponseDto
 */
export interface ReasonCollectResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ReasonCollectResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReasonCollectResponseDto
     */
    'reasonCollectId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReasonCollectResponseDto
     */
    'reasonText'?: string | null;
}
/**
 * 
 * @export
 * @interface RetentionRuleResponseDto
 */
export interface RetentionRuleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof RetentionRuleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetentionRuleResponseDto
     */
    'retentionRuleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RetentionRuleResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RetentionRuleResponseDto
     */
    'days'?: number;
}
/**
 * 
 * @export
 * @interface SearchDataCatalogInput
 */
export interface SearchDataCatalogInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchDataCatalogInput
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchDataCatalogInput
     */
    'primaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchDataCatalogInput
     */
    'secondaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDataCatalogInput
     */
    'fuzzyTableNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDataCatalogInput
     */
    'fuzzyFieldNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchDataCatalogInput
     */
    'encryptMappingStatuses'?: Array<number> | null;
    /**
     * 
     * @type {Array<SearchDataCatalogPath>}
     * @memberof SearchDataCatalogInput
     */
    'searchPaths'?: Array<SearchDataCatalogPath> | null;
}
/**
 * 
 * @export
 * @interface SearchDataCatalogPath
 */
export interface SearchDataCatalogPath {
    /**
     * 
     * @type {number}
     * @memberof SearchDataCatalogPath
     */
    'databaseId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'exactDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'fuzzyDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'exactSchemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'fuzzySchemaName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDataCatalogPath
     */
    'tableId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'exactTableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'fuzzyTableName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDataCatalogPath
     */
    'fieldId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'exactFieldName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDataCatalogPath
     */
    'fuzzyFieldName'?: string | null;
}
/**
 * 
 * @export
 * @interface SearchDataCatalogResponseDto
 */
export interface SearchDataCatalogResponseDto {
    /**
     * 
     * @type {DataCatalogPaginationResult}
     * @memberof SearchDataCatalogResponseDto
     */
    'searchDataCatalogPaginationResult'?: DataCatalogPaginationResult;
    /**
     * 
     * @type {PrimaryClassificationStatisticsResponseDto}
     * @memberof SearchDataCatalogResponseDto
     */
    'primaryClassificationStatistics'?: PrimaryClassificationStatisticsResponseDto;
    /**
     * 
     * @type {EncryptMappingStatusStatisticsResponseDto}
     * @memberof SearchDataCatalogResponseDto
     */
    'encryptMappingStatusStatistics'?: EncryptMappingStatusStatisticsResponseDto;
}
/**
 * 
 * @export
 * @interface SecondaryClassificationResponseDto
 */
export interface SecondaryClassificationResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SecondaryClassificationResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecondaryClassificationResponseDto
     */
    'secondaryClassificationId'?: number;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof SecondaryClassificationResponseDto
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {string}
     * @memberof SecondaryClassificationResponseDto
     */
    'primaryClassificationText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SecondaryClassificationResponseDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SecondaryClassificationResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecondaryClassificationResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SecondaryClassificationResponseDto
     */
    'referenceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecondaryClassificationResponseDto
     */
    'fileReferenceCount'?: number;
}
/**
 * 
 * @export
 * @interface TableOwnershipDto
 */
export interface TableOwnershipDto {
    /**
     * 
     * @type {number}
     * @memberof TableOwnershipDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableOwnershipDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TableOwnershipDto
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableOwnershipDto
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TableOwnershipDto
     */
    'ownerGroupId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TableOwnershipDto
     */
    'ownerGroupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableOwnershipDto
     */
    'databaseName'?: string | null;
}
/**
 * 
 * @export
 * @interface TableSchemaResponseDto
 */
export interface TableSchemaResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TableSchemaResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableSchemaResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableSchemaResponseDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TableSchemaResponseDto
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableSchemaResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableSchemaResponseDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableSchemaResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TableSchemaResponseDto
     */
    'mappedCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TableSchemaResponseDto
     */
    'pendingReviewCount'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateDataAccessRoleInput
 */
export interface UpdateDataAccessRoleInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateDataAccessRoleInput
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataAccessRoleInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataAccessRoleInput
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataAccessRoleInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateDataAccessRoleInput
     */
    'readGrants'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateDataAccessRoleInput
     */
    'writeGrants'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UpdateDataOwnerGroupInput
 */
export interface UpdateDataOwnerGroupInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateDataOwnerGroupInput
     */
    'ownerGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataOwnerGroupInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataOwnerGroupInput
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFieldGovernanceInput
 */
export interface UpdateFieldGovernanceInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'tableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldGovernanceInput
     */
    'alias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldGovernanceInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof UpdateFieldGovernanceInput
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {EncryptMappingStatus}
     * @memberof UpdateFieldGovernanceInput
     */
    'encryptMappingStatus'?: EncryptMappingStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'customEncryptionRuleId'?: number | null;
    /**
     * 
     * @type {MaskingRule}
     * @memberof UpdateFieldGovernanceInput
     */
    'maskingRule'?: MaskingRule;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldGovernanceInput
     */
    'maskingValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'retentionRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldGovernanceInput
     */
    'reasonCollectId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFieldGovernanceInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UpdateReasonCollectInput
 */
export interface UpdateReasonCollectInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateReasonCollectInput
     */
    'reasonCollectId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateReasonCollectInput
     */
    'reasonText': string;
}
/**
 * 
 * @export
 * @interface UpdateRetentionRuleInput
 */
export interface UpdateRetentionRuleInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateRetentionRuleInput
     */
    'retentionRuleId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetentionRuleInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRetentionRuleInput
     */
    'days': number;
}
/**
 * 
 * @export
 * @interface UpdateSecondaryClassificationInput
 */
export interface UpdateSecondaryClassificationInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateSecondaryClassificationInput
     */
    'secondaryClassificationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSecondaryClassificationInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSecondaryClassificationInput
     */
    'description'?: string | null;
}

/**
 * DataAccessRolesApi - axios parameter creator
 * @export
 */
export const DataAccessRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataaccessroles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataaccessrolesIdDelete', 'id', id)
            const localVarPath = `/api/dataaccessroles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataaccessrolesIdGet', 'id', id)
            const localVarPath = `/api/dataaccessroles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDataAccessRoleInput} [updateDataAccessRoleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesIdPut: async (id: number, updateDataAccessRoleInput?: UpdateDataAccessRoleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataaccessrolesIdPut', 'id', id)
            const localVarPath = `/api/dataaccessroles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDataAccessRoleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDataAccessRoleInput} [createDataAccessRoleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesPost: async (createDataAccessRoleInput?: CreateDataAccessRoleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataaccessroles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDataAccessRoleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataAccessRolesApi - functional programming interface
 * @export
 */
export const DataAccessRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataAccessRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataaccessrolesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataAccessRoleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataaccessrolesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataaccessrolesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataaccessrolesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataaccessrolesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataAccessRoleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataaccessrolesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDataAccessRoleInput} [updateDataAccessRoleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataaccessrolesIdPut(id: number, updateDataAccessRoleInput?: UpdateDataAccessRoleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataaccessrolesIdPut(id, updateDataAccessRoleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDataAccessRoleInput} [createDataAccessRoleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataaccessrolesPost(createDataAccessRoleInput?: CreateDataAccessRoleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataaccessrolesPost(createDataAccessRoleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataAccessRolesApi - factory interface
 * @export
 */
export const DataAccessRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataAccessRolesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesGet(options?: any): AxiosPromise<Array<DataAccessRoleResponseDto>> {
            return localVarFp.apiDataaccessrolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataaccessrolesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesIdGet(id: number, options?: any): AxiosPromise<DataAccessRoleResponseDto> {
            return localVarFp.apiDataaccessrolesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDataAccessRoleInput} [updateDataAccessRoleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesIdPut(id: number, updateDataAccessRoleInput?: UpdateDataAccessRoleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataaccessrolesIdPut(id, updateDataAccessRoleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDataAccessRoleInput} [createDataAccessRoleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataaccessrolesPost(createDataAccessRoleInput?: CreateDataAccessRoleInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDataaccessrolesPost(createDataAccessRoleInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataAccessRolesApi - object-oriented interface
 * @export
 * @class DataAccessRolesApi
 * @extends {BaseAPI}
 */
export class DataAccessRolesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAccessRolesApi
     */
    public apiDataaccessrolesGet(options?: AxiosRequestConfig) {
        return DataAccessRolesApiFp(this.configuration).apiDataaccessrolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAccessRolesApi
     */
    public apiDataaccessrolesIdDelete(id: number, options?: AxiosRequestConfig) {
        return DataAccessRolesApiFp(this.configuration).apiDataaccessrolesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAccessRolesApi
     */
    public apiDataaccessrolesIdGet(id: number, options?: AxiosRequestConfig) {
        return DataAccessRolesApiFp(this.configuration).apiDataaccessrolesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateDataAccessRoleInput} [updateDataAccessRoleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAccessRolesApi
     */
    public apiDataaccessrolesIdPut(id: number, updateDataAccessRoleInput?: UpdateDataAccessRoleInput, options?: AxiosRequestConfig) {
        return DataAccessRolesApiFp(this.configuration).apiDataaccessrolesIdPut(id, updateDataAccessRoleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDataAccessRoleInput} [createDataAccessRoleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAccessRolesApi
     */
    public apiDataaccessrolesPost(createDataAccessRoleInput?: CreateDataAccessRoleInput, options?: AxiosRequestConfig) {
        return DataAccessRolesApiFp(this.configuration).apiDataaccessrolesPost(createDataAccessRoleInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataOwnerGroupsApi - axios parameter creator
 * @export
 */
export const DataOwnerGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EditTablesOwnershipInput} [editTablesOwnershipInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsAssignPut: async (editTablesOwnershipInput?: EditTablesOwnershipInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataownergroups/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editTablesOwnershipInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsDatabaseDatabaseIdOwnershipGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDataownergroupsDatabaseDatabaseIdOwnershipGet', 'databaseId', databaseId)
            const localVarPath = `/api/dataownergroups/database/{databaseId}/ownership`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataownergroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdAssignmentBriefGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataownergroupsIdAssignmentBriefGet', 'id', id)
            const localVarPath = `/api/dataownergroups/{id}/assignment-brief`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataownergroupsIdDelete', 'id', id)
            const localVarPath = `/api/dataownergroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataownergroupsIdGet', 'id', id)
            const localVarPath = `/api/dataownergroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDataOwnerGroupInput} [updateDataOwnerGroupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdPut: async (id: number, updateDataOwnerGroupInput?: UpdateDataOwnerGroupInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataownergroupsIdPut', 'id', id)
            const localVarPath = `/api/dataownergroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDataOwnerGroupInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsOverviewGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataownergroups/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDataOwnerGroupInput} [createDataOwnerGroupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsPost: async (createDataOwnerGroupInput?: CreateDataOwnerGroupInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataownergroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDataOwnerGroupInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataOwnerGroupsApi - functional programming interface
 * @export
 */
export const DataOwnerGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataOwnerGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EditTablesOwnershipInput} [editTablesOwnershipInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsAssignPut(editTablesOwnershipInput?: EditTablesOwnershipInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsAssignPut(editTablesOwnershipInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsDatabaseDatabaseIdOwnershipGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableOwnershipDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsDatabaseDatabaseIdOwnershipGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataOwnerGroupResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsIdAssignmentBriefGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OwnerGroupAssignmentBrief>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsIdAssignmentBriefGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataOwnerGroupResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDataOwnerGroupInput} [updateDataOwnerGroupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsIdPut(id: number, updateDataOwnerGroupInput?: UpdateDataOwnerGroupInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsIdPut(id, updateDataOwnerGroupInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsOverviewGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatabaseOwnershipStatsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsOverviewGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDataOwnerGroupInput} [createDataOwnerGroupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataownergroupsPost(createDataOwnerGroupInput?: CreateDataOwnerGroupInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataownergroupsPost(createDataOwnerGroupInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataOwnerGroupsApi - factory interface
 * @export
 */
export const DataOwnerGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataOwnerGroupsApiFp(configuration)
    return {
        /**
         * 
         * @param {EditTablesOwnershipInput} [editTablesOwnershipInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsAssignPut(editTablesOwnershipInput?: EditTablesOwnershipInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataownergroupsAssignPut(editTablesOwnershipInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsDatabaseDatabaseIdOwnershipGet(databaseId: number, options?: any): AxiosPromise<Array<TableOwnershipDto>> {
            return localVarFp.apiDataownergroupsDatabaseDatabaseIdOwnershipGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsGet(options?: any): AxiosPromise<Array<DataOwnerGroupResponseDto>> {
            return localVarFp.apiDataownergroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdAssignmentBriefGet(id: number, options?: any): AxiosPromise<OwnerGroupAssignmentBrief> {
            return localVarFp.apiDataownergroupsIdAssignmentBriefGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataownergroupsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdGet(id: number, options?: any): AxiosPromise<DataOwnerGroupResponseDto> {
            return localVarFp.apiDataownergroupsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDataOwnerGroupInput} [updateDataOwnerGroupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsIdPut(id: number, updateDataOwnerGroupInput?: UpdateDataOwnerGroupInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataownergroupsIdPut(id, updateDataOwnerGroupInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsOverviewGet(options?: any): AxiosPromise<Array<DatabaseOwnershipStatsDto>> {
            return localVarFp.apiDataownergroupsOverviewGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDataOwnerGroupInput} [createDataOwnerGroupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataownergroupsPost(createDataOwnerGroupInput?: CreateDataOwnerGroupInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDataownergroupsPost(createDataOwnerGroupInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataOwnerGroupsApi - object-oriented interface
 * @export
 * @class DataOwnerGroupsApi
 * @extends {BaseAPI}
 */
export class DataOwnerGroupsApi extends BaseAPI {
    /**
     * 
     * @param {EditTablesOwnershipInput} [editTablesOwnershipInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsAssignPut(editTablesOwnershipInput?: EditTablesOwnershipInput, options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsAssignPut(editTablesOwnershipInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsDatabaseDatabaseIdOwnershipGet(databaseId: number, options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsDatabaseDatabaseIdOwnershipGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsGet(options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsIdAssignmentBriefGet(id: number, options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsIdAssignmentBriefGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsIdDelete(id: number, options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsIdGet(id: number, options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateDataOwnerGroupInput} [updateDataOwnerGroupInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsIdPut(id: number, updateDataOwnerGroupInput?: UpdateDataOwnerGroupInput, options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsIdPut(id, updateDataOwnerGroupInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsOverviewGet(options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsOverviewGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDataOwnerGroupInput} [createDataOwnerGroupInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataOwnerGroupsApi
     */
    public apiDataownergroupsPost(createDataOwnerGroupInput?: CreateDataOwnerGroupInput, options?: AxiosRequestConfig) {
        return DataOwnerGroupsApiFp(this.configuration).apiDataownergroupsPost(createDataOwnerGroupInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FieldTagsApi - axios parameter creator
 * @export
 */
export const FieldTagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldtagsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fieldtags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFieldTagInput} [createFieldTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldtagsPost: async (createFieldTagInput?: CreateFieldTagInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fieldtags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFieldTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FieldTagsApi - functional programming interface
 * @export
 */
export const FieldTagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FieldTagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldtagsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldTagResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldtagsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateFieldTagInput} [createFieldTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldtagsPost(createFieldTagInput?: CreateFieldTagInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldtagsPost(createFieldTagInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FieldTagsApi - factory interface
 * @export
 */
export const FieldTagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FieldTagsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldtagsGet(options?: any): AxiosPromise<Array<FieldTagResponseDto>> {
            return localVarFp.apiFieldtagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateFieldTagInput} [createFieldTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldtagsPost(createFieldTagInput?: CreateFieldTagInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiFieldtagsPost(createFieldTagInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FieldTagsApi - object-oriented interface
 * @export
 * @class FieldTagsApi
 * @extends {BaseAPI}
 */
export class FieldTagsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldTagsApi
     */
    public apiFieldtagsGet(options?: AxiosRequestConfig) {
        return FieldTagsApiFp(this.configuration).apiFieldtagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateFieldTagInput} [createFieldTagInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldTagsApi
     */
    public apiFieldtagsPost(createFieldTagInput?: CreateFieldTagInput, options?: AxiosRequestConfig) {
        return FieldTagsApiFp(this.configuration).apiFieldtagsPost(createFieldTagInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FieldsApi - axios parameter creator
 * @export
 */
export const FieldsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsBulkfailedidsPost: async (bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/bulkfailedids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateFieldGovernanceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsBulkhelpPost: async (searchDataCatalogInput?: SearchDataCatalogInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/bulkhelp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDataCatalogInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsBulkupdatePost: async (bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/bulkupdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateFieldGovernanceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateFieldGovernanceInput} [updateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsDatacatalogPost: async (updateFieldGovernanceInput?: UpdateFieldGovernanceInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/datacatalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFieldGovernanceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsEncryptionruledatatypemappingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/encryptionruledatatypemapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsExportPost: async (searchDataCatalogInput?: SearchDataCatalogInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDataCatalogInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditCollectionMappingInput} [editCollectionMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsCollectionEditPut: async (editCollectionMappingInput?: EditCollectionMappingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/mappings/collection/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editCollectionMappingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet: async (databaseId: number, collectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet', 'databaseId', databaseId)
            // verify required parameter 'collectionId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet', 'collectionId', collectionId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}/collections/{collectionId}/properties`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"collectionId"}}`, encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdCollectionsGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdCollectionsGet', 'databaseId', databaseId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}/collections`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdCountsGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdCountsGet', 'databaseId', databaseId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}/counts`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdGet', 'databaseId', databaseId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet', 'databaseId', databaseId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}/pendingcollections`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet', 'databaseId', databaseId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}/pendingtables`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdTablesGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdTablesGet', 'databaseId', databaseId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}/tables`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet: async (databaseId: number, tableId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet', 'databaseId', databaseId)
            // verify required parameter 'tableId' is not null or undefined
            assertParamExists('apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet', 'tableId', tableId)
            const localVarPath = `/api/fields/mappings/databases/{databaseId}/tables/{tableId}/fields`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"tableId"}}`, encodeURIComponent(String(tableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditEncryptionMappingInput} [editEncryptionMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsEditPut: async (editEncryptionMappingInput?: EditEncryptionMappingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/mappings/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editEncryptionMappingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsTableCopyDryPost: async (encryptSettingsCopyInput?: EncryptSettingsCopyInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/mappings/table/copy/dry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encryptSettingsCopyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsTableCopyPost: async (encryptSettingsCopyInput?: EncryptSettingsCopyInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/mappings/table/copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encryptSettingsCopyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsSearchPost: async (page?: number, limit?: number, searchDataCatalogInput?: SearchDataCatalogInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fields/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDataCatalogInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FieldsApi - functional programming interface
 * @export
 */
export const FieldsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FieldsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsBulkfailedidsPost(bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkUpdateValidationFailedIdsResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsBulkfailedidsPost(bulkUpdateFieldGovernanceInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsBulkhelpPost(searchDataCatalogInput?: SearchDataCatalogInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataCatalogSelectAllItemResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsBulkhelpPost(searchDataCatalogInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsBulkupdatePost(bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsBulkupdatePost(bulkUpdateFieldGovernanceInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateFieldGovernanceInput} [updateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsDatacatalogPost(updateFieldGovernanceInput?: UpdateFieldGovernanceInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsDatacatalogPost(updateFieldGovernanceInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsEncryptionruledatatypemappingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionRuleDataTypeMappingResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsEncryptionruledatatypemappingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsExportPost(searchDataCatalogInput?: SearchDataCatalogInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsExportPost(searchDataCatalogInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EditCollectionMappingInput} [editCollectionMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsCollectionEditPut(editCollectionMappingInput?: EditCollectionMappingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsCollectionEditPut(editCollectionMappingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet(databaseId: number, collectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PropertyMappingResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet(databaseId, collectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdCollectionsGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CollectionSchemaResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdCollectionsGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdCountsGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseMappingCountsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdCountsGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncryptionMappingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CollectionSchemaResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableSchemaResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdTablesGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableSchemaResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdTablesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId: number, tableId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldMappingResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId, tableId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EditEncryptionMappingInput} [editEncryptionMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsEditPut(editEncryptionMappingInput?: EditEncryptionMappingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsEditPut(editEncryptionMappingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionMappingResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsTableCopyDryPost(encryptSettingsCopyInput?: EncryptSettingsCopyInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncryptSettingsCopyAnalyseInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsTableCopyDryPost(encryptSettingsCopyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsMappingsTableCopyPost(encryptSettingsCopyInput?: EncryptSettingsCopyInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsMappingsTableCopyPost(encryptSettingsCopyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFieldsSearchPost(page?: number, limit?: number, searchDataCatalogInput?: SearchDataCatalogInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDataCatalogResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFieldsSearchPost(page, limit, searchDataCatalogInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FieldsApi - factory interface
 * @export
 */
export const FieldsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FieldsApiFp(configuration)
    return {
        /**
         * 
         * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsBulkfailedidsPost(bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options?: any): AxiosPromise<Array<BulkUpdateValidationFailedIdsResponseDto>> {
            return localVarFp.apiFieldsBulkfailedidsPost(bulkUpdateFieldGovernanceInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsBulkhelpPost(searchDataCatalogInput?: SearchDataCatalogInput, options?: any): AxiosPromise<Array<DataCatalogSelectAllItemResponseDto>> {
            return localVarFp.apiFieldsBulkhelpPost(searchDataCatalogInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsBulkupdatePost(bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFieldsBulkupdatePost(bulkUpdateFieldGovernanceInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateFieldGovernanceInput} [updateFieldGovernanceInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsDatacatalogPost(updateFieldGovernanceInput?: UpdateFieldGovernanceInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFieldsDatacatalogPost(updateFieldGovernanceInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsEncryptionruledatatypemappingGet(options?: any): AxiosPromise<Array<EncryptionRuleDataTypeMappingResponseDto>> {
            return localVarFp.apiFieldsEncryptionruledatatypemappingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsExportPost(searchDataCatalogInput?: SearchDataCatalogInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFieldsExportPost(searchDataCatalogInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditCollectionMappingInput} [editCollectionMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsCollectionEditPut(editCollectionMappingInput?: EditCollectionMappingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFieldsMappingsCollectionEditPut(editCollectionMappingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet(databaseId: number, collectionId: number, options?: any): AxiosPromise<Array<PropertyMappingResponseDto>> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet(databaseId, collectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdCollectionsGet(databaseId: number, options?: any): AxiosPromise<Array<CollectionSchemaResponseDto>> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdCollectionsGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdCountsGet(databaseId: number, options?: any): AxiosPromise<DatabaseMappingCountsResponseDto> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdCountsGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdGet(databaseId: number, options?: any): AxiosPromise<EncryptionMappingResponseDto> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet(databaseId: number, options?: any): AxiosPromise<Array<CollectionSchemaResponseDto>> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet(databaseId: number, options?: any): AxiosPromise<Array<TableSchemaResponseDto>> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdTablesGet(databaseId: number, options?: any): AxiosPromise<Array<TableSchemaResponseDto>> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdTablesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId: number, tableId: number, options?: any): AxiosPromise<Array<FieldMappingResponseDto>> {
            return localVarFp.apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId, tableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditEncryptionMappingInput} [editEncryptionMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsEditPut(editEncryptionMappingInput?: EditEncryptionMappingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFieldsMappingsEditPut(editEncryptionMappingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsGet(options?: any): AxiosPromise<Array<EncryptionMappingResponseDto>> {
            return localVarFp.apiFieldsMappingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsTableCopyDryPost(encryptSettingsCopyInput?: EncryptSettingsCopyInput, options?: any): AxiosPromise<EncryptSettingsCopyAnalyseInfoDto> {
            return localVarFp.apiFieldsMappingsTableCopyDryPost(encryptSettingsCopyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsMappingsTableCopyPost(encryptSettingsCopyInput?: EncryptSettingsCopyInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFieldsMappingsTableCopyPost(encryptSettingsCopyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFieldsSearchPost(page?: number, limit?: number, searchDataCatalogInput?: SearchDataCatalogInput, options?: any): AxiosPromise<SearchDataCatalogResponseDto> {
            return localVarFp.apiFieldsSearchPost(page, limit, searchDataCatalogInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FieldsApi - object-oriented interface
 * @export
 * @class FieldsApi
 * @extends {BaseAPI}
 */
export class FieldsApi extends BaseAPI {
    /**
     * 
     * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsBulkfailedidsPost(bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsBulkfailedidsPost(bulkUpdateFieldGovernanceInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsBulkhelpPost(searchDataCatalogInput?: SearchDataCatalogInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsBulkhelpPost(searchDataCatalogInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateFieldGovernanceInput} [bulkUpdateFieldGovernanceInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsBulkupdatePost(bulkUpdateFieldGovernanceInput?: BulkUpdateFieldGovernanceInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsBulkupdatePost(bulkUpdateFieldGovernanceInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateFieldGovernanceInput} [updateFieldGovernanceInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsDatacatalogPost(updateFieldGovernanceInput?: UpdateFieldGovernanceInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsDatacatalogPost(updateFieldGovernanceInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsEncryptionruledatatypemappingGet(options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsEncryptionruledatatypemappingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsExportPost(searchDataCatalogInput?: SearchDataCatalogInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsExportPost(searchDataCatalogInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditCollectionMappingInput} [editCollectionMappingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsCollectionEditPut(editCollectionMappingInput?: EditCollectionMappingInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsCollectionEditPut(editCollectionMappingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {number} collectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet(databaseId: number, collectionId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdCollectionsCollectionIdPropertiesGet(databaseId, collectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdCollectionsGet(databaseId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdCollectionsGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdCountsGet(databaseId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdCountsGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet(databaseId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdPendingcollectionsGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet(databaseId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdPendingtablesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdTablesGet(databaseId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdTablesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {number} tableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId: number, tableId: number, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId, tableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditEncryptionMappingInput} [editEncryptionMappingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsEditPut(editEncryptionMappingInput?: EditEncryptionMappingInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsEditPut(editEncryptionMappingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsGet(options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsTableCopyDryPost(encryptSettingsCopyInput?: EncryptSettingsCopyInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsTableCopyDryPost(encryptSettingsCopyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EncryptSettingsCopyInput} [encryptSettingsCopyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsMappingsTableCopyPost(encryptSettingsCopyInput?: EncryptSettingsCopyInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsMappingsTableCopyPost(encryptSettingsCopyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {SearchDataCatalogInput} [searchDataCatalogInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public apiFieldsSearchPost(page?: number, limit?: number, searchDataCatalogInput?: SearchDataCatalogInput, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).apiFieldsSearchPost(page, limit, searchDataCatalogInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GovernanceDashboardApi - axios parameter creator
 * @export
 */
export const GovernanceDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sort] 
         * @param {boolean} [ascending] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGovncDashboardGet: async (page?: number, limit?: number, sort?: string, ascending?: boolean, term?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/govnc-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['ascending'] = ascending;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GovernanceDashboardApi - functional programming interface
 * @export
 */
export const GovernanceDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GovernanceDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sort] 
         * @param {boolean} [ascending] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGovncDashboardGet(page?: number, limit?: number, sort?: string, ascending?: boolean, term?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDatabaseStatisResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGovncDashboardGet(page, limit, sort, ascending, term, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GovernanceDashboardApi - factory interface
 * @export
 */
export const GovernanceDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GovernanceDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sort] 
         * @param {boolean} [ascending] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGovncDashboardGet(page?: number, limit?: number, sort?: string, ascending?: boolean, term?: string, options?: any): AxiosPromise<DashboardDatabaseStatisResponseDtoPaginationResult> {
            return localVarFp.apiGovncDashboardGet(page, limit, sort, ascending, term, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GovernanceDashboardApi - object-oriented interface
 * @export
 * @class GovernanceDashboardApi
 * @extends {BaseAPI}
 */
export class GovernanceDashboardApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [sort] 
     * @param {boolean} [ascending] 
     * @param {string} [term] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GovernanceDashboardApi
     */
    public apiGovncDashboardGet(page?: number, limit?: number, sort?: string, ascending?: boolean, term?: string, options?: AxiosRequestConfig) {
        return GovernanceDashboardApiFp(this.configuration).apiGovncDashboardGet(page, limit, sort, ascending, term, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OptionsApi - axios parameter creator
 * @export
 */
export const OptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesDatabaseIdGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiOptionsDatabasesDatabaseIdGet', 'databaseId', databaseId)
            const localVarPath = `/api/options/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesDatabaseIdSchemasSchemaGet: async (databaseId: number, schema: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiOptionsDatabasesDatabaseIdSchemasSchemaGet', 'databaseId', databaseId)
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('apiOptionsDatabasesDatabaseIdSchemasSchemaGet', 'schema', schema)
            const localVarPath = `/api/options/databases/{databaseId}/schemas/{schema}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesDatabaseIdTablesTableIdGet: async (databaseId: number, tableId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiOptionsDatabasesDatabaseIdTablesTableIdGet', 'databaseId', databaseId)
            // verify required parameter 'tableId' is not null or undefined
            assertParamExists('apiOptionsDatabasesDatabaseIdTablesTableIdGet', 'tableId', tableId)
            const localVarPath = `/api/options/databases/{databaseId}/tables/{tableId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"tableId"}}`, encodeURIComponent(String(tableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/options/databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OptionsApi - functional programming interface
 * @export
 */
export const OptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsDatabasesDatabaseIdGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsDatabasesDatabaseIdSchemasSchemaGet(databaseId: number, schema: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsDatabasesDatabaseIdSchemasSchemaGet(databaseId, schema, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsDatabasesDatabaseIdTablesTableIdGet(databaseId: number, tableId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsDatabasesDatabaseIdTablesTableIdGet(databaseId, tableId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsDatabasesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsDatabasesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OptionsApi - factory interface
 * @export
 */
export const OptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesDatabaseIdGet(databaseId: number, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiOptionsDatabasesDatabaseIdGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesDatabaseIdSchemasSchemaGet(databaseId: number, schema: string, options?: any): AxiosPromise<Array<EnumOptionResponseDto>> {
            return localVarFp.apiOptionsDatabasesDatabaseIdSchemasSchemaGet(databaseId, schema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesDatabaseIdTablesTableIdGet(databaseId: number, tableId: number, options?: any): AxiosPromise<Array<EnumOptionResponseDto>> {
            return localVarFp.apiOptionsDatabasesDatabaseIdTablesTableIdGet(databaseId, tableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsDatabasesGet(options?: any): AxiosPromise<Array<EnumOptionResponseDto>> {
            return localVarFp.apiOptionsDatabasesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OptionsApi - object-oriented interface
 * @export
 * @class OptionsApi
 * @extends {BaseAPI}
 */
export class OptionsApi extends BaseAPI {
    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public apiOptionsDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsDatabasesDatabaseIdGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {string} schema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public apiOptionsDatabasesDatabaseIdSchemasSchemaGet(databaseId: number, schema: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsDatabasesDatabaseIdSchemasSchemaGet(databaseId, schema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {number} tableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public apiOptionsDatabasesDatabaseIdTablesTableIdGet(databaseId: number, tableId: number, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsDatabasesDatabaseIdTablesTableIdGet(databaseId, tableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public apiOptionsDatabasesGet(options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsDatabasesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReasonCollectApi - axios parameter creator
 * @export
 */
export const ReasonCollectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/reasoncollect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReasoncollectIdDelete', 'id', id)
            const localVarPath = `/api/reasoncollect/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReasoncollectIdGet', 'id', id)
            const localVarPath = `/api/reasoncollect/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateReasonCollectInput} [updateReasonCollectInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectIdPut: async (id: number, updateReasonCollectInput?: UpdateReasonCollectInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReasoncollectIdPut', 'id', id)
            const localVarPath = `/api/reasoncollect/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReasonCollectInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReasonCollectInput} [createReasonCollectInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectPost: async (createReasonCollectInput?: CreateReasonCollectInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/reasoncollect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReasonCollectInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReasonCollectApi - functional programming interface
 * @export
 */
export const ReasonCollectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReasonCollectApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReasoncollectGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReasonCollectResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReasoncollectGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReasoncollectIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReasoncollectIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReasoncollectIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReasonCollectResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReasoncollectIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateReasonCollectInput} [updateReasonCollectInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReasoncollectIdPut(id: number, updateReasonCollectInput?: UpdateReasonCollectInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReasoncollectIdPut(id, updateReasonCollectInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReasonCollectInput} [createReasonCollectInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReasoncollectPost(createReasonCollectInput?: CreateReasonCollectInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReasoncollectPost(createReasonCollectInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReasonCollectApi - factory interface
 * @export
 */
export const ReasonCollectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReasonCollectApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectGet(options?: any): AxiosPromise<Array<ReasonCollectResponseDto>> {
            return localVarFp.apiReasoncollectGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiReasoncollectIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectIdGet(id: number, options?: any): AxiosPromise<ReasonCollectResponseDto> {
            return localVarFp.apiReasoncollectIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateReasonCollectInput} [updateReasonCollectInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectIdPut(id: number, updateReasonCollectInput?: UpdateReasonCollectInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiReasoncollectIdPut(id, updateReasonCollectInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReasonCollectInput} [createReasonCollectInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReasoncollectPost(createReasonCollectInput?: CreateReasonCollectInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiReasoncollectPost(createReasonCollectInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReasonCollectApi - object-oriented interface
 * @export
 * @class ReasonCollectApi
 * @extends {BaseAPI}
 */
export class ReasonCollectApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReasonCollectApi
     */
    public apiReasoncollectGet(options?: AxiosRequestConfig) {
        return ReasonCollectApiFp(this.configuration).apiReasoncollectGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReasonCollectApi
     */
    public apiReasoncollectIdDelete(id: number, options?: AxiosRequestConfig) {
        return ReasonCollectApiFp(this.configuration).apiReasoncollectIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReasonCollectApi
     */
    public apiReasoncollectIdGet(id: number, options?: AxiosRequestConfig) {
        return ReasonCollectApiFp(this.configuration).apiReasoncollectIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateReasonCollectInput} [updateReasonCollectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReasonCollectApi
     */
    public apiReasoncollectIdPut(id: number, updateReasonCollectInput?: UpdateReasonCollectInput, options?: AxiosRequestConfig) {
        return ReasonCollectApiFp(this.configuration).apiReasoncollectIdPut(id, updateReasonCollectInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReasonCollectInput} [createReasonCollectInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReasonCollectApi
     */
    public apiReasoncollectPost(createReasonCollectInput?: CreateReasonCollectInput, options?: AxiosRequestConfig) {
        return ReasonCollectApiFp(this.configuration).apiReasoncollectPost(createReasonCollectInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RetentionRuleApi - axios parameter creator
 * @export
 */
export const RetentionRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/retentionrule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRetentionruleIdDelete', 'id', id)
            const localVarPath = `/api/retentionrule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRetentionruleIdGet', 'id', id)
            const localVarPath = `/api/retentionrule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateRetentionRuleInput} [updateRetentionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleIdPut: async (id: number, updateRetentionRuleInput?: UpdateRetentionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRetentionruleIdPut', 'id', id)
            const localVarPath = `/api/retentionrule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRetentionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRetentionRuleInput} [createRetentionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionrulePost: async (createRetentionRuleInput?: CreateRetentionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/retentionrule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRetentionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RetentionRuleApi - functional programming interface
 * @export
 */
export const RetentionRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RetentionRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRetentionruleGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RetentionRuleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRetentionruleGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRetentionruleIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRetentionruleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRetentionruleIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetentionRuleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRetentionruleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateRetentionRuleInput} [updateRetentionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRetentionruleIdPut(id: number, updateRetentionRuleInput?: UpdateRetentionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRetentionruleIdPut(id, updateRetentionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRetentionRuleInput} [createRetentionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRetentionrulePost(createRetentionRuleInput?: CreateRetentionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRetentionrulePost(createRetentionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RetentionRuleApi - factory interface
 * @export
 */
export const RetentionRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RetentionRuleApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleGet(options?: any): AxiosPromise<Array<RetentionRuleResponseDto>> {
            return localVarFp.apiRetentionruleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiRetentionruleIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleIdGet(id: number, options?: any): AxiosPromise<RetentionRuleResponseDto> {
            return localVarFp.apiRetentionruleIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateRetentionRuleInput} [updateRetentionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionruleIdPut(id: number, updateRetentionRuleInput?: UpdateRetentionRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiRetentionruleIdPut(id, updateRetentionRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRetentionRuleInput} [createRetentionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRetentionrulePost(createRetentionRuleInput?: CreateRetentionRuleInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiRetentionrulePost(createRetentionRuleInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RetentionRuleApi - object-oriented interface
 * @export
 * @class RetentionRuleApi
 * @extends {BaseAPI}
 */
export class RetentionRuleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionRuleApi
     */
    public apiRetentionruleGet(options?: AxiosRequestConfig) {
        return RetentionRuleApiFp(this.configuration).apiRetentionruleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionRuleApi
     */
    public apiRetentionruleIdDelete(id: number, options?: AxiosRequestConfig) {
        return RetentionRuleApiFp(this.configuration).apiRetentionruleIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionRuleApi
     */
    public apiRetentionruleIdGet(id: number, options?: AxiosRequestConfig) {
        return RetentionRuleApiFp(this.configuration).apiRetentionruleIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateRetentionRuleInput} [updateRetentionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionRuleApi
     */
    public apiRetentionruleIdPut(id: number, updateRetentionRuleInput?: UpdateRetentionRuleInput, options?: AxiosRequestConfig) {
        return RetentionRuleApiFp(this.configuration).apiRetentionruleIdPut(id, updateRetentionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRetentionRuleInput} [createRetentionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionRuleApi
     */
    public apiRetentionrulePost(createRetentionRuleInput?: CreateRetentionRuleInput, options?: AxiosRequestConfig) {
        return RetentionRuleApiFp(this.configuration).apiRetentionrulePost(createRetentionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SecondaryClassificationsApi - axios parameter creator
 * @export
 */
export const SecondaryClassificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [includeRefCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsGet: async (includeRefCount?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/secondaryclassifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeRefCount !== undefined) {
                localVarQueryParameter['includeRefCount'] = includeRefCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSecondaryclassificationsIdDelete', 'id', id)
            const localVarPath = `/api/secondaryclassifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsIdGrantsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSecondaryclassificationsIdGrantsGet', 'id', id)
            const localVarPath = `/api/secondaryclassifications/{id}/grants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSecondaryClassificationInput} [updateSecondaryClassificationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsIdPut: async (id: number, updateSecondaryClassificationInput?: UpdateSecondaryClassificationInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSecondaryclassificationsIdPut', 'id', id)
            const localVarPath = `/api/secondaryclassifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSecondaryClassificationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSecondaryClassificationInput} [createSecondaryClassificationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsPost: async (createSecondaryClassificationInput?: CreateSecondaryClassificationInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/secondaryclassifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSecondaryClassificationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecondaryClassificationsApi - functional programming interface
 * @export
 */
export const SecondaryClassificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecondaryClassificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeRefCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecondaryclassificationsGet(includeRefCount?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SecondaryClassificationResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecondaryclassificationsGet(includeRefCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecondaryclassificationsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecondaryclassificationsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecondaryclassificationsIdGrantsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassificationGrantsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecondaryclassificationsIdGrantsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSecondaryClassificationInput} [updateSecondaryClassificationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecondaryclassificationsIdPut(id: number, updateSecondaryClassificationInput?: UpdateSecondaryClassificationInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecondaryclassificationsIdPut(id, updateSecondaryClassificationInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSecondaryClassificationInput} [createSecondaryClassificationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecondaryclassificationsPost(createSecondaryClassificationInput?: CreateSecondaryClassificationInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecondaryclassificationsPost(createSecondaryClassificationInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecondaryClassificationsApi - factory interface
 * @export
 */
export const SecondaryClassificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecondaryClassificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeRefCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsGet(includeRefCount?: boolean, options?: any): AxiosPromise<Array<SecondaryClassificationResponseDto>> {
            return localVarFp.apiSecondaryclassificationsGet(includeRefCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiSecondaryclassificationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsIdGrantsGet(id: number, options?: any): AxiosPromise<ClassificationGrantsDto> {
            return localVarFp.apiSecondaryclassificationsIdGrantsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSecondaryClassificationInput} [updateSecondaryClassificationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsIdPut(id: number, updateSecondaryClassificationInput?: UpdateSecondaryClassificationInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiSecondaryclassificationsIdPut(id, updateSecondaryClassificationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSecondaryClassificationInput} [createSecondaryClassificationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecondaryclassificationsPost(createSecondaryClassificationInput?: CreateSecondaryClassificationInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiSecondaryclassificationsPost(createSecondaryClassificationInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecondaryClassificationsApi - object-oriented interface
 * @export
 * @class SecondaryClassificationsApi
 * @extends {BaseAPI}
 */
export class SecondaryClassificationsApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [includeRefCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondaryClassificationsApi
     */
    public apiSecondaryclassificationsGet(includeRefCount?: boolean, options?: AxiosRequestConfig) {
        return SecondaryClassificationsApiFp(this.configuration).apiSecondaryclassificationsGet(includeRefCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondaryClassificationsApi
     */
    public apiSecondaryclassificationsIdDelete(id: number, options?: AxiosRequestConfig) {
        return SecondaryClassificationsApiFp(this.configuration).apiSecondaryclassificationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondaryClassificationsApi
     */
    public apiSecondaryclassificationsIdGrantsGet(id: number, options?: AxiosRequestConfig) {
        return SecondaryClassificationsApiFp(this.configuration).apiSecondaryclassificationsIdGrantsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateSecondaryClassificationInput} [updateSecondaryClassificationInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondaryClassificationsApi
     */
    public apiSecondaryclassificationsIdPut(id: number, updateSecondaryClassificationInput?: UpdateSecondaryClassificationInput, options?: AxiosRequestConfig) {
        return SecondaryClassificationsApiFp(this.configuration).apiSecondaryclassificationsIdPut(id, updateSecondaryClassificationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSecondaryClassificationInput} [createSecondaryClassificationInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondaryClassificationsApi
     */
    public apiSecondaryclassificationsPost(createSecondaryClassificationInput?: CreateSecondaryClassificationInput, options?: AxiosRequestConfig) {
        return SecondaryClassificationsApiFp(this.configuration).apiSecondaryclassificationsPost(createSecondaryClassificationInput, options).then((request) => request(this.axios, this.basePath));
    }
}


